import React from "react";

interface LineProps {
  type: "solid" | "dashed";
}

export const Line: React.FC<LineProps> = ({ type }) => {
  return <hr style={{ borderStyle: type }} />;
};
